import { Button, Input, Space, Table } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import React from 'react';

function ETLMappingEditor({ initialFieldMapping = [], onMappingChange }) {
    const [mappings, setMappings] = React.useState(initialFieldMapping);

    // Cập nhật mappings khi editingSchema thay đổi
    React.useEffect(() => {
        setMappings(initialFieldMapping);
    }, [initialFieldMapping]);

    const handleAddRow = () => {
        const newMappings = [...mappings, { sourceField: '', targetField: '',value:'' }];
        setMappings(newMappings);
        onMappingChange(newMappings);
    };

    const handleFieldChange = (index, key, value) => {
        const updated = [...mappings];
        updated[index][key] = value;
        setMappings(updated);
        onMappingChange(updated);
    };

    const handleRemoveRow = (index) => {
        const updated = mappings.filter((_, i) => i !== index);
        setMappings(updated);
        onMappingChange(updated);
    };

    const columns = [
        {
            title: 'Source Field',
            dataIndex: 'sourceField',
            render: (_, record, index) => (
                <Input
                    value={record.sourceField}
                    onChange={(e) => handleFieldChange(index, 'sourceField', e.target.value)}
                />
            ),
        },
        {
            title: 'Target Field',
            dataIndex: 'targetField',
            render: (_, record, index) => (
                <Input
                    value={record.targetField}
                    onChange={(e) => handleFieldChange(index, 'targetField', e.target.value)}
                />
            ),
        },
        {
            title: 'Default Value',
            dataIndex: 'value',
            render: (_, record, index) => (
                <Input
                    value={record.value}
                    onChange={(e) => handleFieldChange(index, 'value', e.target.value)}
                />
            ),
        },
        {
            title: '',
            dataIndex: 'actions',
            render: (_, __, index) => (
                <Button icon={<DeleteOutlined />} danger onClick={() => handleRemoveRow(index)} />
            ),
            width: 50,
        },
    ];

    return (
        <>
            <Table
                dataSource={mappings.map((m, i) => ({ key: i, ...m }))}
                columns={columns}
                pagination={false}
            />
            <Button
                type="dashed"
                onClick={handleAddRow}
                icon={<PlusOutlined />}
                style={{ marginTop: 12 }}
                block
            >
                Thêm dòng Mapping
            </Button>
        </>
    );
}

export default ETLMappingEditor;
